import { c as _c } from "react/compiler-runtime";
import { Stack, Text, Icon, SystemStyleObject } from "@chakra-ui/react";
type KeyElemProps = {
  name: string;
  color: SystemStyleObject["color"];
  icon: React.ReactNode;
};
export const KeyElem = t0 => {
  const $ = _c(10);
  const {
    name,
    color,
    icon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "sm",
      md: "md"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== color || $[2] !== icon) {
    t2 = <Icon size={t1} color={color}>{icon}</Icon>;
    $[1] = color;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      base: "textSmall",
      md: "textMedium"
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== name) {
    t4 = <Text textStyle={t3} layerStyle="headerAlt" fontWeight="bold" whiteSpace="nowrap">{name}</Text>;
    $[5] = name;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Stack direction="row" alignItems="center">{t2}{t4}</Stack>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};